import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import * as S from './InformationField.styles'

interface SxProps {
  container: S.ContainerProps
  title: S.TitleProps
  containerInfo: S.ContainerInfoProps
}

interface InformationFieldProps {
  title: string
  tooltipTitleMessage?: string
  tooltipTitleIcon?: JSX.Element
  tooltipTitleAlertColor?: string
  info: string
  tooltipInfoMessage?: string
  tooltipInfoIcon?: JSX.Element
  sxProps?: SxProps
  testId?: string
}

const InformationField = ({
  title,
  tooltipTitleMessage,
  tooltipTitleIcon,
  tooltipTitleAlertColor,
  info,
  tooltipInfoMessage,
  tooltipInfoIcon,
  sxProps = {
    container: {
      gap: '.5rem',
    },
    title: {
      fontWeight: 600,
      fontSize: '14px',
    },
    containerInfo: {},
  },
  testId = 'information-field-test-id',
}: InformationFieldProps) => (
  <S.Container {...sxProps.container} data-testid={testId}>
    <S.Title {...sxProps.title}>
      {title}
      {tooltipTitleMessage && (
      <S.TooltipTitle
        sx={{ cursor: 'pointer' }}
        title={tooltipTitleMessage}
        placement='top'
        arrow
        data-testid='alert-tooltip-test-id'
      >
        {tooltipTitleIcon || (
        <ReportProblemIcon
          sx={{
            width: '19px',
            height: '19px',
            marginLeft: '.3rem',
            marginTop: '-.2rem',
          }}
          htmlColor={tooltipTitleAlertColor}
        />
        )}
      </S.TooltipTitle>
      )}
    </S.Title>
    <S.ContainerInfo {...sxProps.containerInfo}>
      <S.Info>
        {info}
      </S.Info>
      {tooltipInfoMessage && (
      <S.TooltipInfo
        title={tooltipInfoMessage}
        placement='top'
        arrow
      >
        {tooltipInfoIcon || <InfoOutlinedIcon />}
      </S.TooltipInfo>
      )}
    </S.ContainerInfo>
  </S.Container>
)

export default InformationField
